export const HIDDEN_BOUNDARY = 300;
export const BASE_WIDTH = 1920;
export const BASE_HEIGHT = 1080;
export const CONTROLS_HEIGHT = 50;
export const DEFAULT_DEATHBEAM_RADIUS = 2;
export const NULL_ENTITY = 0;
export const ENTITY_START_CURSOR = 1;
export const MAX_ENTITIES = 100_000;
export const GHOST_SHOT_STEPS = 500;